
import { useAppStore } from '@/store/app'
import Vue from 'vue'

export default Vue.extend({
  name: 'SignerLookup',
  props: {
    signerId: {
      type: String,
      default: ''
    }
  },
  watch: {
    async signerId () {
      this.selectedSigner = this.signers.find((signer) => signer.id === this.signerId)
    }
  },
  setup () {
    const app = useAppStore()

    return {
      app
    }
  },
  data () {
    return {
      signers: new Array<any>(),
      selectedSigner: {}
    }
  },
  async mounted () {
    this.fetch()
    this.emitInterface()
  },
  methods: {
    normalizeText (text: string) {
      return text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },
    filterData (item: any, queryText: string) {
      const normalizedQuery = this.normalizeText(queryText)
      return (
        this.normalizeText(item.name).includes(normalizedQuery) ||
        this.normalizeText(item.lastname).includes(normalizedQuery) ||
        this.normalizeText(item.id).includes(normalizedQuery) ||
        this.normalizeText(item.historyNumber).includes(normalizedQuery)
      )
    },
    changeValue (value: { name: string; id: string; lastname: string } | null) {
      this.$emit('changed', value ? { name: value.name, id: value.id, lastname: value.lastname } : value)
    },
    clear () {
      this.selectedSigner = {}
    },
    async fetch () {
      const user = this.app.selectedClient?.id ?? ''
      const res = await fetch(`${process.env.VUE_APP_API_URL}/${user}/signers`)
      const data = await res.json()
      const signers = Object.keys(data).map(id => data[id]).filter((signer) => !!signer.id)

      this.signers = signers
      this.selectedSigner = this.signers.find((signer) => signer.id === this.signerId)
    },
    /**
     * Emitting an interface with callable methods from outside
     */
    emitInterface () {
      this.$emit('interface', {
        clear: () => this.clear(),
        refetch: async () => this.fetch()
      })
    }
  }
})
